import _ from 'lodash';

function setItem(key, value) {
	if (!window.localStorage) {
		return;
	}
	if (_.isUndefined(value)) {
		return;
	}

	try {
		window.localStorage.setItem(key, JSON.stringify(value));
	} catch (e) {}
}

function getItem(key) {
	if (!window.localStorage) {
		return;
	}

	let ret;
	try {
		const val = window.localStorage.getItem(key);
		if (!_.isUndefined(val) && val !== null) {
			ret = JSON.parse(val);
		}
	} catch {}

	return ret;
}

const localStorageExport = {
	setItem,
	getItem,
};

export default localStorageExport;
